import type { Strings } from "../i18n/strings";
import { ARCHETYPE_NAME, kickerSep, locDate } from "../i18n/strings";
import { archetypeColor } from "../lib/archetypeMeta";
import { useEffect } from "react";
import { useCountUp } from "../lib/useMotion";
import { playStamp } from "../lib/sound";
import { hapticStamp } from "../lib/native";
import { deriveDisplayStats } from "../lib/displayStats";
import type { Lang, VerdictResult } from "../lib/types";
import AngerCurveViz from "./AngerCurveViz";
import TypeArt from "./TypeArt";

interface Props {
  t: Strings;
  lang: Lang;
  result: VerdictResult;
  onDetail: () => void; // 정밀 분석 → 광고 게이트
  onShare: () => void; // 자랑하기 → 공유 카드
  onClose: () => void; // ✕ → 홈
}

// ⑤ 상단 카드 (무료): 점수 + AI 멘트 + 유형 배지. 하단은 블러 잠금 티저(광고 게이트).
export default function Report({ t, lang, result, onDetail, onShare, onClose }: Props) {
  const { score, judgement, curve, archetype, signals } = result;
  const color = archetypeColor(archetype);
  const name = ARCHETYPE_NAME[archetype][lang];
  const stats = deriveDisplayStats(signals);
  const shown = useCountUp(score);

  // 판정 등장 = 도장 쾅(히어로 2). 환호 팡파레 없음.
  useEffect(() => {
    playStamp();
    hapticStamp();
  }, []);

  return (
    <div className="screen report">
      <div className="rep-header">
        <button className="navbtn" onClick={onClose}>
          ✕ {t.close}
        </button>
      </div>

      <div className="rep-top">
        <span className="rep-meta">BWEK · {locDate(lang)}</span>
      </div>

      <div className="type-badge">
        <TypeArt typeId={archetype} accent={color} ink="#fff" size={72} sw={3.2} draw />
        <div className="badge">
          <span className="kicker" style={{ color }}>
            {t.kicker}
          </span>
          {kickerSep(lang)}
          <span className="type-name">{name}</span>
        </div>
      </div>

      <div className="score" style={{ color }}>
        {shown}
        <span className="score-suffix">/100</span>
      </div>

      <div className="ai-line">
        <span className="ai-label" style={{ color }}>
          {t.aiLine}
        </span>
        <p className="headline">“{judgement.headline}”</p>
      </div>

      {/* 블러 잠금 티저 */}
      <button className="lock-teaser" onClick={onDetail}>
        <div className="lock-blur">
          <AngerCurveViz curve={curve} color={color} w={300} h={56} showAxis />
          <div className="lock-stats">
            <span>
              {t.stSpeed} {stats.speed}
            </span>
            <span>
              {t.stBack} {stats.backspaces}
            </span>
            <span>
              {t.stTime} {stats.timeSpentSec}s
            </span>
          </div>
        </div>
        <div className="lock-overlay" style={{ color }}>
          🔒 {t.lockMore}
        </div>
      </button>

      <div className="rep-cta">
        <button className="cta-solid" style={{ background: color }} onClick={onShare}>
          {t.flexit}
        </button>
        <button className="cta-outline" style={{ borderColor: color, color }} onClick={onDetail}>
          {t.detailButton}
        </button>
      </div>
    </div>
  );
}
